<template lang="pug">
v-container(v-if="$store.state.user && $store.state.user.role === 1")
	v-window(v-model="page" touchless)
		v-window-item
			v-row(wrap)
				v-col(md=6)
					v-row(wrap)
						//- v-col(md=6)
						//- 	v-select(v-model="category" :items="categories" @change="getSurvey()" placeholder="類別")
						v-col(md=6)
							v-select(v-model="identity" :items="identities" item-text="text" item-value="value" @change="getSurvey()" placeholder="身分")
						v-col(md=6)
							v-btn.ma-1.orange(dark @click="copyFromLastYear" :disabled="!canCopyFromLastYear" :loading="copying")
								| 複製去年問卷
				v-col(md=6)
					v-btn.ma-1.cyan(dark @click="newQuestion('blank')") 空白
					v-btn.ma-1.cyan(dark @click="newQuestion('satisfy')") 滿意
					v-btn.ma-1.cyan(dark @click="newQuestion('complete')") 完善
					v-btn.ma-1.cyan(dark @click="newQuestion('score')") 評分
					v-btn.ma-1.cyan(dark @click="autosort()") 自動排序
			draggable(v-model="questions" @start="drag=true" @end="drag=false")
				v-card(v-for="(qs,qi) in questions" :key="qi").px-2.pb-2.mb-3
					v-layout(align-center)
						v-icon(:style="inputStyle(qs)").pa-2.mx-2.bdr mdi-menu
						v-text-field(label="指標" v-model="qs.index").mx-2
						v-select(label="類別" v-model="qs.category" :items="categoryOptions" placeholder="選擇類別").mx-2
						select(v-model="qs.color" :style="{background: qs.color.p}").rect
							option(v-for="color in colors" :key="color.p" :value="color" :style="{background: color.p}") 
					v-layout.mb-2
						textarea(v-model="qs.q" placeholder="題目" :style="inputStyle(qs)").pa-2.input
						v-icon.pa-2.bdr(:style="inputStyle(qs)" @click="removeOption(qs)") mdi-close
						v-icon.pa-2.bdr(:style="inputStyle(qs)" @click="qs.opts.push({t:'',s:0})") mdi-plus
						select.pa-2.bdr(v-model="qs.type" @change="qs.select=qs.type.includes('複選題')?[]:null" :style="inputStyle(qs)")
							option 配分單選題
							option 單選題
							option 複選題
							option 評分
							option 簡答
							option 文字詳述
							option 單選題與其他
							option 複選題與其他
						.bdr(:style="inputStyle(qs)").pa-2.d-flex.align-center
							.input(:style="inputStyle(qs)") 配分分數
							input(type="number" v-model.number="qs.max_score" :style="inputStyle(qs)").input.ml-2
						v-icon.pa-2.bdr(:style="inputStyle(qs)" @click="deleteQuestion(qs, qi)") mdi-delete
					v-layout.bdr(v-if="qs.type.includes('選')")
						input(v-for="(opt,oi) in qs.opts" :key="oi" :placeholder="'選項'+String.fromCharCode(97 + oi).toUpperCase()" type="text" v-model="opt.t").input
					v-layout.bdr(v-if="qs.type.includes('配分')")
						input(v-for="(opt,oi) in qs.opts" :key="oi" :placeholder="'配分'+String.fromCharCode(97 + oi).toUpperCase()" type="number" v-model.number="opt.s").input
					v-layout.bdr(v-if="qs.type=='評分'")
						.input(:style="inputStyle(qs)") 最小
						input(type="number" v-model="qs.min").input
						.input(:style="inputStyle(qs)") 最大
						input(type="number" v-model="qs.max").input
						.input(:style="inputStyle(qs)") 配分
						input(type="number" v-model="qs.quota").input
		v-window-item
			v-layout(row wrap v-for="(qs,qi) in questions" :key="qi").my-3
				v-flex(xs12 md6 :style="inputStyle(qs)").d-flex.align-center
					span.px-5.py-2.subheading {{qs.q}}
				v-flex(xs12 md6 v-if="qs.type.includes('單選題')")
					v-btn.ma-1(v-for="(opt,oi) in qs.opts" :key="oi" @click="qs.select=opt" :style="radioStyle(opt,qs)")
						.badge(:style="{background: qs.color.p}") {{String.fromCharCode(97 + oi).toUpperCase()}}
						span {{opt.t}}
					v-btn.ma-1(v-if="qs.type.includes('其他')")
						.badge(:style="{background: qs.color.p}") 其他
						input(type="text" v-model="qs.other" :style="{borderColor: qs.color.p}").bdr.text-xs-center
				v-flex(xs12 md6 v-else-if="qs.type.includes('複選題')")
					v-layout(row wrap align-center justify-start).px-5.pt-4
						v-checkbox.mt-0(style="height:40px" v-for="(opt,oi) in qs.opts" :key="oi" v-model="qs.select" :value="opt.t" :label="opt.t" :color="qs.color.p")
						.mx-2(style="height:40px" v-if="qs.type.includes('其他')" label)
							.badge(:style="{background: qs.color.p}") 其他
							input(type="text" v-model="qs.other" :style="{borderColor: qs.color.p}").bdr.text-xs-center
				v-flex(xs12 md6 v-else)
					v-layout(v-if="qs.type=='評分'" :style="inputStyle(qs)" align-center).px-3
						.badge(:style="{background: qs.color.p}") 評分
						v-slider(thumb-label="always" :color="qs.color.p" :max="qs.max" :min="qs.min" v-model.number="qs.select").mx-3
					.pa-2(v-if="qs.type=='簡答'")
						.badge(:style="{background: qs.color.p}") 簡答
						input(type="text").bdr.text-xs-center
					.bdr(v-if="qs.type=='文字詳述'" :style="inputStyle(qs)").pa-2
						textarea(style="background: #fff").input
	v-layout.psf
		v-btn.ma-1(fab @click="page=page?0:1")
			v-icon(v-if="page") mdi-toggle-switch
			v-icon(v-else) mdi-toggle-switch-off
		v-btn.ma-1(fab @click="save()" :disabled="saving" :loading="saving")
			v-icon mdi-content-save
	v-snackbar(v-model="snackbar" :timeout="1000") 儲存成功
</template>

<script>
import { db, colors } from '../main';
import draggable from 'vuedraggable';
import axios from 'axios';

export default {
	name: 'design',
	components: { draggable },
	data() {
		return {
			drag: false,
			page: 0,
			snackbar: false,
			category: '',
			categories: [],
			identity: '',
			identities: [],
			colors,
			categoryOptions: [],
			questionnaires:[],
			copying: false,
			hasCurrentYearContent: false,
			questions: [],
			saving: false,
		};
	},
	methods: {
		inputStyle(qs) {
			return { background: qs.color.l, color: qs.color.d, borderColor: qs.color.p };
		},
		radioStyle(opt, qs) {
			return {
				color: qs.select == opt ? 'white' : qs.color.p,
				background: qs.select == opt ? qs.color.p : 'white',
				borderColor: qs.color.p,
			};
		},
		// 題目選項類型對應的ID
		getTypeId(type) {
			const typeMap = {
				'配分單選題': 1,
				'單選題': 2,
				'複選題': 3,
				'評分': 4,
				'簡答': 5,
				'文字詳述': 6,
				'單選題與其他': 7,
				'複選題與其他': 8,
			};
			return typeMap[type] || 1;
		},
		// 題目類型對應的ID
		getItemId(item) {
			const itemMap = {
				'空白': 1,
				'滿意': 2,
				'完善': 3,
				'評分': 4,
				'自動排序': 5,
			};
			return itemMap[item] || 1;
		},
		// 題目類型ID對應的中文
		getTypeName(typeId) {
			const typeMap = {
				1: '配分單選題',
				2: '單選題',
				3: '複選題',
				4: '評分',
				5: '簡答',
				6: '文字詳述',
				7: '單選題與其他',
				8: '複選題與其他',
			};
			const result = typeMap[typeId] || '配分單選題';
			return result;
		},
		// 題目類別對應的ID
		getCategoryName(categoryId) {
			const categoryMap = {
				1: '推動單位',
				2: '客運業者',
				3: '推動單位 + 客運業者',
			};
			const result = categoryMap[categoryId] || '推動單位';
			return result;
		},
		parseColor(colorStr) {
			// 預設顏色
			if (!colorStr) {
				return { p: '#00bcd4', l: '#b2ebf2', d: '#006064' };
			}
			
			const foundColor = this.colors.find(c => c.p === colorStr);
			if (foundColor) {
				return foundColor;
			}
			
            // 將十六進制顏色代碼轉換成RGB
			const rgb = this.hexToRgb(colorStr);
			if (rgb) {
				return {
					p: colorStr,
					l: this.rgbToHex(Math.min(255, rgb.r + 100), Math.min(255, rgb.g + 100), Math.min(255, rgb.b + 100)),
					d: this.rgbToHex(Math.max(0, rgb.r - 50), Math.max(0, rgb.g - 50), Math.max(0, rgb.b - 50))
				};
			}
			
			return { p: colorStr, l: '#b2ebf2', d: '#006064' };
		},
		// 解析十六進制顏色代碼
		hexToRgb(hex) {
			if (!hex) return null;
			
			const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null;
		},
		// RGB轉回十六進制顏色代碼
		rgbToHex(r, g, b) {
			return "#" + ((1 << 24) + (Math.round(r) << 16) + (Math.round(g) << 8) + Math.round(b)).toString(16).slice(1);
		},
		// 問卷題目預設樣式
		newQuestion(opt_type) {
			var opts = [];
			switch (opt_type) {
				case 'satisfy':
					opts = [
						{ t: '非常滿意', s: 5 },
						{ t: '滿意', s: 3 },
						{ t: '普通', s: 2 },
						{ t: '不滿意', s: 1 },
						{ t: '非常不滿意', s: 0 },
					];
					break;
				case 'complete':
					opts = [
						{ t: '服務完善', s: 5 },
						{ t: '大部分完善', s: 3 },
						{ t: '少部分完善', s: 1 },
						{ t: '無此服務', s: 0 },
					];
					break;
				case 'score':
					opts = [
						{ t: '5', s: 5 },
						{ t: '4', s: 4 },
						{ t: '3', s: 3 },
						{ t: '2', s: 2 },
						{ t: '1', s: 1 },
						{ t: '0', s: 0 },
					];
					break;
				default:
					opts = [];
					break;
			}
			this.questions.unshift({
				q: '',
				index: '',
				type: '配分單選題',
				color: { p: '#00bcd4', l: '#b2ebf2', d: '#006064' },
				opts: opts,
				select: null,
				other: '',
				max: 100,
				min: 0,
				quota: 5,
				max_score:0,
			});
		},
		// 取得問卷題目
		async getSurvey() {
			if (!this.identity) {
				this.questions = [];
				return;
			}

			const year = this.$store.state.selectedYear;

			try {
				const response = await axios.get('/api/Questionnaire/QuestionnaireList',{
					params: {
						year: year,
						identity_id: parseInt(this.identity, 10)
					}
				});
				
				if (response.data.status && response.data.result) {
					// 用身分ID找到對應的問卷
					const identityId = parseInt(this.identity);
					const questionnaire = response.data.result.find(q => q.identity_id === identityId);
					
					if (questionnaire) {
						if (questionnaire.questions && questionnaire.questions.length > 0) {
							const convertedQuestions = questionnaire.questions.map((q, index) => {
								try {
									// 轉換選項格式
									const opts = (q.options || []).map(opt => ({
										option_id: opt.option_id || 0,
										t: opt.option_name || '',
										s: opt.score || 0
									}));
									
									const typeName = this.getTypeName(q.questionnaire_type_id) || '配分單選題';
									const colorObj = this.parseColor(q.color);
									
									const convertedQuestion = {
										q: q.question_name || '',
										index: q.tag || '',
										category: q.category_id || null,
										type: typeName,
										color: colorObj,
										opts: opts.length > 0 ? opts : [{ t: '', s: 0 }],
										select: typeName.includes('複選題') ? [] : null, 
										other: '',
										max: 100,
										min: 0,
										quota: 5,
										max_score: q.max_score || 0,
										question_id: q.question_id,
										questionnaire_id: q.questionnaire_id
									};
									
									// 回傳轉換後的題目
									return convertedQuestion;
								} catch (error) {
									return null;
								}
							}).filter(q => q !== null);
							
							this.questions = convertedQuestions;
							// 頁面更新
							this.$nextTick(() => {
								// 重新渲染
								this.$forceUpdate();
							});
						} 
					} else {
						this.questions = [];
					}
				} 
			} catch (error) {
				this.questions = [];
			}
		},
		async loadAllOptions(){
			// 取得身分列表
			const identityResponse = await axios.get('/api/Account/IdentityList');
			if (identityResponse.data.status && identityResponse.data.result) {
				this.identities = identityResponse.data.result.map(identity => ({
					text: identity.name,
					value: identity.id
				}));
			} else {
				this.identities = [];
			}

			// 取得類別列表
			const categoryResponse = await axios.get('/api/Account/CategoryList');
			if (categoryResponse.data.status && categoryResponse.data.result) {
				this.categories = categoryResponse.data.result.map(category => category.name);
				this.categoryOptions = categoryResponse.data.result.map(category => ({
					text: category.name,
					value: category.id
				}));
			} else {
				this.categories = [];
				this.categoryOptions = [];
			}
		},
		// 複製去年問卷
		async copyFromLastYear() {
			if (!this.identity) {
				alert('請先選擇身分');
				return;
			}
			this.copying = true;
			try {
				const year = this.$store.state.selectedYear;
				const response = await axios.post('/api/Questionnaire/CopyQuestionnaire', null, {
					params: {
						year: parseInt(year, 10),
						identity_id: parseInt(this.identity, 10),
					},
				});
				if (response.data.status) {
					await this.getSurvey();
					this.snackbar = true;
				} else {
					alert(response.data.message || '複製失敗');
				}
			} catch (error) {
				console.error('複製去年問卷錯誤:', error);
				alert('複製失敗: ' + (error.response?.data?.message || error.message));
			} finally {
				this.copying = false;
			}
		},
		// 儲存問卷
		async save() {
			if (!this.identity) {
				alert('請先選擇身分');
				return;
			}

			if (this.saving) return; // 已在儲存中則直接離開
    		this.saving = true;

			const year = this.$store.state.selectedYear;

			try {
				// 查看問卷ID
				const existingQuestionnaireId = this.questions.find(qs => qs.questionnaire_id && qs.questionnaire_id > 0)?.questionnaire_id;
				// 是否有問卷ID
				const hasExistingQuestionnaire = existingQuestionnaireId && existingQuestionnaireId > 0;
				// 有ID帶ID， 沒有新增ID帶0
				const questionnaireId = hasExistingQuestionnaire ? existingQuestionnaireId : 0;
				
				// 組成API payload
				const payload = {
					id: questionnaireId,
					year: parseInt(year, 10), 
					identity_id: parseInt(this.identity) || 0,
					questions: this.questions.map((qs, index) => {
						return {
							id: qs.question_id || 0, 
							questionnaire_id: questionnaireId, 
							questionnaire_item_id: this.getItemId(qs.item) || 1, 
							questionnaire_type_id: this.getTypeId(qs.type),
							category_id: parseInt(qs.category) || 0,
							tag: qs.index || '',
							name: qs.q || '',
							max_score: qs.max_score || 0,
							color: qs.color.p || '#00bcd4',
							sort: index,
							options: (qs.opts || []).map(opt => ({
								id: opt.option_id || 0,
								questionnaire_question_id: qs.question_id || 0,
								name: opt.t || '',
								score: qs.type.includes('配分') ? (opt.s || 0) : 0
							}))
						};
					})
				};

				const apiUrl = hasExistingQuestionnaire 
					? '/api/Questionnaire/Update' 
					: '/api/Questionnaire/Create';
								
				const response = await axios.post(apiUrl, payload);
				
				if (response.data.status) {
					this.page = 0;
					this.snackbar = true;
					await this.getSurvey();
				} else {
					alert(response.data.message || '儲存失敗');
				}
			} catch (error) {
				console.error('儲存問卷錯誤:', error);
				alert('儲存失敗: ' + (error.response?.data?.message || error.message));
			} finally {
				this.saving = false;
			}
		},
		// 刪除問卷選項
		async removeOption(qs) {
			if (!qs.opts || qs.opts.length === 0) return;
			const oi = qs.opts.length - 1;
			const opt = qs.opts[oi];
			if (opt.option_id) {
				try {
					const response = await axios.post('/api/Questionnaire/DeleteOption', null, {
						params: {
							questionnaire_question_id: qs.question_id,
							option_id: opt.option_id
						}
					});
					if (response.data.status) {
						qs.opts.splice(oi, 1);
					} else {
						alert(response.data.message || '刪除選項失敗');
					}
				} catch (error) {
					console.error('刪除選項錯誤:', error);
					alert('刪除選項失敗: ' + (error.response?.data?.message || error.message));
				}
			} else {
				qs.opts.splice(oi, 1);
			}
		},
		// 刪除問卷題目
		async deleteQuestion(qs, qi) {
			if (!qs.question_id || qs.question_id === 0) {
				this.questions.splice(qi, 1);
				return;
			}

			try {
				const response = await axios.post('/api/Questionnaire/Delete', null, {
					params: {
						question_id: qs.question_id
					}
				});

				if (response.data.status) {
					this.questions.splice(qi, 1);
					this.$nextTick(() => {
						this.$forceUpdate();
					});
				} else {
					alert(response.data.message || '刪除失敗');
				}
			} catch (error) {
				console.error('刪除問題錯誤:', error);
			}
		},
		// 問卷題目排序
		autosort() {
			this.questions.sort((a, b) => {
				let compare = a.index.localeCompare(b.index);
				if (compare == 0) return a.q.localeCompare(b.q);
				else return compare;
			});
		},
	},
	computed: {
		canCopyFromLastYear() {
			if (!this.identity) return false;
			if (!Array.isArray(this.questions) || this.questions.length === 0) return true;
			const hasAnySavedQuestion = this.questions.some(
				(q) => q.question_id != null && q.question_id > 0
			);
			return !hasAnySavedQuestion;
		},
	},
	// 監聽selectedYear的變化
	watch: {
		'$store.state.selectedYear'() {
			this.getSurvey();
		},
	},
	// 初始化
	mounted() {
		this.loadAllOptions();
	},
};
</script>
